module.exports = __webpack_public_path__ + "static/media/market_hover.a7ac6fc9.svg";